import React from "react";

export default function MSAccess_Abs() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Abs</h1>
      <p>This is the MSAccess_Abs component generated from the SQL JSON.</p>
    </div>
  );
}
